import React from 'react';
import { Modal, Image, Typography } from 'antd';

const { Text } = Typography;

const ImagePopupModal = ({ visible, images, onClose }) => {
  return (
    <Modal
      title="View Uploades"
      centered
      visible={visible}
      onCancel={onClose}
      onOk={onClose}
      footer={null}
      destroyOnClose
      className="custom-modal"
    >
      {images.length > 0 ? (
        <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
          {images.map((image, index) => (
            <div key={index} style={{ margin: '10px' }}>
              <Image src={image.url} alt={`Image ${index + 1}`} width={200} />
            </div>
          ))}
        </div>
      ) : (
        <Text>No records found.</Text>
      )}
    </Modal>
  );
};

export default ImagePopupModal;
